import { Environment } from './environment.interfaces';

export const environment: Environment = {
  production: false,
  sandbox: true,
  CONNECT_URL: 'https://develop.virtamed.cloud/',
  API_HOST: 'https://appdevelop.virtamed.cloud/api/',
  version: 'Develop 1.7.0',
  theme: 'ethicon',
  simulatorIdentifier: 'd3b76b9a-58f8-45f0-bade-396c9369cc87',
};
